import React from 'react';
import { Container, Row, Col, Button, Modal, Table } from 'react-bootstrap';

const EvntHistoryModal = ({ show, onHide, eventData }) => {
  if (!eventData) return null;

  return (
    <Container className="p-0">
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton style={{ background: '#fff', color: '#000', borderBottom: '1px solid #ccc' }}>
          <Modal.Title>{eventData.event_name}</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ background: '#fff', color: '#000' }}>
          <Row>
            <Col md={6}>
              <p><strong>Date:</strong> {eventData.event_date}</p>
              <p><strong>Time:</strong> {eventData.time_range}</p>
              <p><strong>Venue:</strong> {eventData.venue}</p>
              <p><strong>Address:</strong> {eventData.address}</p>
            </Col>
            <Col md={6}>
              <p><strong>Max Participants:</strong> {eventData.max_participants}</p>
              <p><strong>Permission:</strong> {eventData.permission}</p>
              <p><strong>Organizer:</strong> {eventData.organizer_name}</p>
            </Col>
          </Row>

          <Row>
            <Col>
              <p><strong>Description:</strong> {eventData.description}</p>
            </Col>
          </Row>

          <Row>
            <Col>
              <h5>Participants</h5>
              <Table
                striped
                bordered
                hover
                size="sm"
                responsive
                style={{ backgroundColor: '#fff', color: '#000' }}
              >
                <thead>
                  <tr>
                    <th style={{ border: '1px solid #ccc', color: '#000' }}>Name</th>
                    <th style={{ border: '1px solid #ccc', color: '#000' }}>Email</th>
                    <th style={{ border: '1px solid #ccc', color: '#000' }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {(eventData.participants || []).map((p, i) => (
                    <tr key={i} style={{ border: '1px solid #ccc' }}>
                      <td style={{ border: '1px solid #ccc', color: '#000' }}>{p.participant_name}</td>
                      <td style={{ border: '1px solid #ccc', color: '#000' }}>{p.participant_email}</td>
                      <td style={{ border: '1px solid #ccc', color: '#000' }}>{p.participant_status}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer style={{ background: '#fff', borderTop: '1px solid #ccc' }}>
          <Button variant="dark" onClick={onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default EvntHistoryModal;
